import PropTypes from 'prop-types'
import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import { connect } from 'react-redux'
import { Icon, FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon, MarkerIcon, ForwardIcon, HomeIcon, DotIcon, BackIcon } from '../../core/icons'

import { Checkbox, Radio, Input, Select, Switch, Button as AButton, DatePicker, Row, Col, Tooltip, Icon as AIcon } from 'antd';
import Card, { TitleCard, CardHeader } from '../../core/Card'
import Line from '../../core/Line'
import { save, addCustom, toggle } from './actions'
import './BusinessLines.css'
import { reduxForm, hasSubmitSucceeded, hasSubmitFailed, Field, submit } from 'redux-form'

import styled from 'styled-components'

import { selectPersona } from './actions'
import { BusinessLine } from './BusinessLines'

const WorkStatus = ({persona, toggle})=>
  <div>

    <BusinessLine
      key={1}
      name={'Self-Employed'}
      selected={persona.includes('Self-Employed')}
      toggle={toggle}
    >
    {'Self-Employed'}
    </BusinessLine>
    <BusinessLine
      key={2}
      name={'Employee'}
      selected={persona.includes('Employee')}
      toggle={toggle}
    >
      {'Employee'}
      </BusinessLine>

      <div style={{paddingTop:'30px', cursor:'pointer', opacity: '.6'}}>
        <Tooltip
          title={
            "If you're an employee using Everlance for reimbursement or tracking business expenses for your employer, select 'Employee.' If you're an independent contractor or a self-employed individual using Everlance for tax deductions, select 'Self-Employed.' You can also select both."
          }
          >
            Which should I choose?
            <AIcon style={{marginLeft: "20px"}} type="question-circle-o" />
          </Tooltip>
      </div>
  </div>
 

const mapStateToProps = (state) => {
  return {
    persona: state.account.businessLines.persona
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggle: (persona)=>dispatch(selectPersona(persona, ownProps.form)),
    // onRemoteSubmit: ownProps.onRemoteSubmit
  }
}

WorkStatus.propTypes = {
  persona: PropTypes.array.isRequired,
  // submitting: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkStatus)



// WEBPACK FOOTER //
// ./src/account/business-lines/WorkStatus.js